import React, { useState } from "react";
import { Link } from "react-router-dom";
import "../../../../../scss/pages/workout.css";
import BenefitsComponent from "../../../details/BenefitsComponent";
import VideoComponent from "../../../details/VideoComponent";
import Header from "../../subcategory/Header";
import { useTranslation } from "react-i18next";

const Dhanurasana = () => {
    const [muscleVideo, setMuscelVideo] = useState("video");
    const {t} = useTranslation();
    const contentObject = [
      { title: t("Dhanurasana.title1"), context: t("Dhanurasana.context1") },
      { title: t("Dhanurasana.title2"), context: t("Dhanurasana.context2") },
      { title: t("Dhanurasana.title3"), context: t("Dhanurasana.context3") },
      { title: t("Dhanurasana.title4"), context: t("Dhanurasana.context4") },
      { title: t("Dhanurasana.title5"), context: t("Dhanurasana.context5") },
      { title: t("Dhanurasana.title6"), context: t("Dhanurasana.context6") },
      { title: t("Dhanurasana.title7"), context: t("Dhanurasana.context7") }
    ];
  
  
    return (
      <>
        <Header headtitle={t("Dhanurasana.title")} />
        <div className="workOutWrap">
          <div className="workoutButtonWrap">
            <Link
              to="#"
              className={muscleVideo === "video" ? "active" : null}
              onClick={() => {
                setMuscelVideo("video");
              }}
            >
              Video
            </Link>
            <Link
              to="#"
              className={muscleVideo === "benefits" ? "active" : null}
              onClick={() => {
                setMuscelVideo("benefits");
              }}
            >
              Benefits
            </Link>
          </div>
          <div className="videoWrapper">
            {muscleVideo === "video" ? (
              <VideoComponent
                workoutVideo={'https://tickhigh.s3.ca-central-1.amazonaws.com/Wellness360/Yoga/dhanurasana.mp4'}
                title="Description"
                context={t("Dhanurasana.description")}
                muscleTitle={false}
                muscleImg={false}
              />
            ) : (
              <BenefitsComponent
                context=""
                title="Description"
                benfits={false}
                contentObj={contentObject}
              />
            )}
          </div>
        </div>
      </>
    );
  };

export default Dhanurasana
